import { render } from "./ItsAMatch.vue?vue&type=template&id=9725a56a&scoped=true"
import script from "./ItsAMatch.vue?vue&type=script&lang=js"
export * from "./ItsAMatch.vue?vue&type=script&lang=js"

import "./ItsAMatch.vue?vue&type=style&index=0&id=9725a56a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9725a56a"]])

export default __exports__